import {SET_SELECTED_LOCATIONS} from '../actions/SetupAction'

const initialState ={    
    selectedLocations:null
}

const SetupReducer =  (state= initialState, action)=>{
    switch(action.type){
        case SET_SELECTED_LOCATIONS: 
        return {...state, selectedLocations:action.selectedLocations}   
      
        default:
            return {...state}
    }
}

export default SetupReducer;